export enum CpdRecordStatusEnum {
    Declined = "DCN",
    RequiresFurtherAction = "RFA",
    Unverified = "UV",
    Verified = "VF",
}